export default {
  apiUrl: 'https://api.ama-loc.fr/api',
  clientApiUrl: 'https://cabinet-api.ama-loc.fr/api',
}
